import React from 'react';
import '../../components/CSS/About.css';
import ContactHero from '../../components/ContactHero';
import ContactUs from '../../components/ContactUs';
import SEOHead from '../../components/SEO/SEOHead';
import { seoConfig } from '../../components/SEO/seoConfig';
import { localBusinessSchema, createBreadcrumbSchema } from '../../components/SEO/schemas';

const Contact = () => {
  const breadcrumbs = [
    { name: 'Home', url: process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk' },
    { name: 'Contact', url: `${process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk'}/contact` }
  ];

  const combinedSchema = [localBusinessSchema, createBreadcrumbSchema(breadcrumbs)];

  return (
    <>
      {/* <SEOHead
        title={seoConfig.contact.title}
        description={seoConfig.contact.description}
        keywords={seoConfig.contact.keywords}
        canonical={seoConfig.contact.canonical}
        ogTitle={seoConfig.contact.ogTitle}
        ogDescription={seoConfig.contact.ogDescription}
        ogImage={seoConfig.contact.ogImage}
        ogUrl={seoConfig.contact.canonical}
        structuredData={combinedSchema}
      /> */}
      <div className="about-page">
        <ContactHero />
        <ContactUs />
      </div>
    </>
  );
};

export default Contact;